class FreeShippingBar extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick.bind(this));
  }

  getSectionsToRender() {
    const mainCartItems = document.getElementById('main-cart-items');
    const mainCartFooter = document.getElementById('main-cart-footer');

    return [
      {
        id: 'main-cart-items',
        section: mainCartItems?.dataset.id || 'main-cart-items',
        selector: '.js-contents'
      },
      {
        id: 'main-cart-footer',
        section: mainCartFooter?.dataset.id || 'main-cart-footer',
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '#cart-icon-bubble'
      }
    ];
  }

  async onClick(event) {
    const button = event.target.closest('[data-fs-add]');
    if (!button || button.disabled) return;

    event.preventDefault();

    const variantId = button.dataset.variantId;
    const originalHtml = button.innerHTML;
    const errorElement = this.querySelector('[data-fs-error]');
    const sectionsToRender = this.getSectionsToRender();

    button.disabled = true;
    button.innerHTML = 'Adding...';

    if (errorElement) {
      errorElement.hidden = true;
      errorElement.textContent = '';
    }

    const body = {
      id: Number(variantId),
      quantity: 1,
      sections: sectionsToRender.map((section) => section.section),
      sections_url: window.location.pathname
    };

    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(body)
      });

      const data = await response.json();

      if (!response.ok) throw data;

      if (data.sections) {
        sectionsToRender.forEach((section) => {
          this.replaceSection(section, data.sections[section.section]);
        });

        document.dispatchEvent(new CustomEvent('cart:updated'));
      } else {
        window.location.reload();
      }
    } catch (error) {
      if (errorElement) {
        errorElement.textContent =
          error?.description || 'Could not add this item. Please try again.';
        errorElement.hidden = false;
      }
    } finally {
      if (document.body.contains(button)) {
        button.disabled = false;
        button.innerHTML = originalHtml;
      }
    }
  }

  replaceSection(section, html) {
    if (!html) return;

    const currentElement =
      document.getElementById(section.id) ||
      document.querySelector(section.selector);

    if (!currentElement) return;

    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');

    const newElement =
      parsedHtml.getElementById(section.id) ||
      parsedHtml.querySelector(section.selector);

    if (newElement) {
      currentElement.innerHTML = newElement.innerHTML;
    }
  }
}

if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', FreeShippingBar);
}